import selectWeekStartDayOption from '../data/mutators/selectWeekStartDayOption';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import dateTimeStrings from 'owa-strings/owa-datetime-strings';
import { observer } from 'mobx-react';
import getWeekStartDay from '../selectors/getWeekStartDay';
/**
 * The WeekStartDay parameter specifies the first day of the week. Valid values are:
 * Sunday (default value), Monday, Tuesday, Wednesday, Thursday, Friday, Saturday
 */
export default observer(function WeekStartDay(_a) {
    var showQuickSettingLabel = _a.showQuickSettingLabel, saveWeekStartDayQuickSetting = _a.saveWeekStartDayQuickSetting;
    var dayOfweekOptions = [
        { key: 0, text: dateTimeStrings.calendarDayOfWeek_Sunday },
        { key: 1, text: dateTimeStrings.calendarDayOfWeek_Monday },
        { key: 2, text: dateTimeStrings.calendarDayOfWeek_Tuesday },
        { key: 3, text: dateTimeStrings.calendarDayOfWeek_Wednesday },
        { key: 4, text: dateTimeStrings.calendarDayOfWeek_Thursday },
        { key: 5, text: dateTimeStrings.calendarDayOfWeek_Friday },
        { key: 6, text: dateTimeStrings.calendarDayOfWeek_Saturday },
    ];
    /**
     * Save directly in case of quick setting, otherwise set the value in store
     * @param option dayOfweekOptions item
     */
    var onWeekStartDayChange = function (option) {
        if (saveWeekStartDayQuickSetting) {
            saveWeekStartDayQuickSetting(option.key);
        }
        else {
            selectWeekStartDayOption(option.key);
        }
    };
    var label = showQuickSettingLabel
        ? strings.options_appearance_weekstartdayQuickSettingLabel
        : strings.options_appearance_weekstartdayLabel;
    return (React.createElement(Dropdown, { selectedKey: getWeekStartDay(), label: label, ariaLabel: strings.options_appearance_weekstartdayLabel, options: dayOfweekOptions, onChanged: onWeekStartDayChange }));
});
//# sourceMappingURL=WeekStartDay.js.map